var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.992,
    height: 39.879,
    viewBox: "0 0 32.992 39.879",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M8.5,41A5.5,5.5,0,0,1,3,35.5V17.172q0-.093.009-.184H3a3.98,3.98,0,0,1,1.166-2.815L15.608,2.732a5.5,5.5,0,0,1,7.776,0L34.826,14.174a3.98,3.98,0,0,1,1.166,2.815h-.009q.009.091.009.184V35.5a5.5,5.5,0,0,1-5.5,5.5ZM20.792,5.324,32.326,16.858V35.5a1.833,1.833,0,0,1-1.833,1.833h-5.5V28.17a5.5,5.5,0,1,0-11,0v9.164H8.5A1.833,1.833,0,0,1,6.666,35.5V16.858L18.2,5.324A1.833,1.833,0,0,1,20.792,5.324Z",
    transform: "translate(-3 -1.121)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.46b30cc201214660ebe1f69fa7920bde.svg";
export { ForwardRef as ReactComponent };